var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    {
      key: _vm.key,
      style: _vm.tabsStyling,
      attrs: {
        value: _vm.activeTab,
        "show-arrows": "",
        centered: _vm.centerTabs,
        right: _vm.alignTabsRight
      }
    },
    [
      _c("v-tabs-slider", { attrs: { color: _vm.tabsSliderColor } }),
      _vm._v(" "),
      _vm._l(_vm.tabs, function(tab, index) {
        return _c(
          "v-tab",
          {
            key: tab.label,
            style: [
              _vm.tabsLabelsStyling,
              {
                color: _vm.activeTab === index ? _vm.tabsLabelColor : "#767676"
              }
            ],
            attrs: { disabled: tab.disabled ? tab.disabled : false },
            on: {
              change: function($event) {
                return _vm.$emit("startTabChange", index)
              }
            }
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.translateLabels
                    ? _vm.$tc(_vm.getTranslationKey(tab.label), 2)
                    : tab.label
                ) +
                "\n  "
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b89c3770", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b89c3770","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Atoms/Tabs.vue
// module id = null
// module chunks = 